import { render, staticRenderFns } from "./ChooseWarehouseField.vue?vue&type=template&id=9c4ea898"
import script from "./ChooseWarehouseField.vue?vue&type=script&lang=js"
export * from "./ChooseWarehouseField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports